import React, { HTMLAttributes } from 'react';

const MaxWidth = ({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={`max-width ${className}`.trim()} {...props}>
      {children}
    </div>
  );
};

export default MaxWidth;
